import React, {Component} from 'react';
import {API} from "aws-amplify";
import {Button, Col, FormControl, FormGroup, InputGroup, Modal, Row} from "react-bootstrap";
import "./GiveCredits.css"
export default class GiveCredits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purseObj: {},
      bsClass: 'modal-header modal-header-info',
      modalTitle: 'Give Credits',
      modalMessage: 'Give this user some credits!',
      showModal: false,
      authorized: false,
      userId: '',
      displayedURL: '',
      creditAmount: 0,
      LoadingGiftButton: false
    }
  }
  async componentDidMount(){
    // make sure the person we're trying to give credits to isn't yourself!
    // do an api call to check it this is you or not
    try {
      const profile = await API.get("api", "/profile/me");
      if (profile.displayedURL !== this.props.giveToId && profile.userId !== this.props.giveToId) {
        this.setState({authorized: true});
      }
    }
    catch(e) {
      this.setState({authorized: false});
    }
    this.getPurse();
  }
  async getPurse() {
    try {
      const purse = await API.get("api", "/tokens/purse");
      this.setState({
        purseObj: purse
      });
    } catch (e) {
      this.setState({authorized: false});
    }
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    if (event.target.value > this.state.purseObj.purseQty) {
      this.setState({
        bsClass: 'modal-header modal-header-danger'
      });
    }
    if (event.target.value > this.state.purseObj.purseQty) {
      this.setState({
        bsClass: 'modal-header modal-header-danger'
      });
    }
    if (event.target.value > 0 && event.target.value <= this.state.purseObj.purseQty) {
      this.setState({
        bsClass: 'modal-header modal-header-success'
      });
    }
    if (event.target.value === 0 || event.target.value === '') {
      this.setState({
        bsClass: 'modal-header modal-header-info'
      });
    }
  };
  validateForm() {
    if (this.state.creditAmount > 0 && this.state.creditAmount <= this.state.purseObj.purseQty) return true
  }
  validationState() {
    if (this.state.creditAmount === '') return null;
    if (this.state.creditAmount === 0) return null;
    if (this.state.creditAmount > 0 && this.state.creditAmount > this.state.purseObj.purseQty) return 'error';
    if (this.state.creditAmount > 0 && this.state.creditAmount <= this.state.purseObj.purseQty) return 'success';
  }
  giftForm = () => {
    this.setState({
      bsClass: 'modal-header modal-header-info',
      modalTitle: 'Give Credits',
      modalMessage: 'GIFT',
      showModal: true
    });
  };
  giveCredits = async () => {
    this.setState({LoadingGiftButton: true});
    // send API call to give the credits
    try {
      await API.post("api", "/tokens/gift", {
        body: {
          qty: this.state.creditAmount,
          giveToId: this.props.giveToId
        }
      });
      this.setState({
        bsClass: 'modal-header modal-header-success',
        modalTitle: 'Success',
        modalMessage: `You have given ${this.props.name} ${this.state.creditAmount} credits.`,
        LoadingGiftButton: false
      });
      // recalculate the purse on the menubar
      this.props.recalculatePurse();
      // get the purse amount again to see if you can give any more credits
      this.getPurse();
    } catch (e) {
      let errorMessage = `There was a problem giving ${this.props.name} ${this.state.creditAmount} credits.`;
      if (e.message) {errorMessage = e.message;}
      if (e.response) {errorMessage = e.response.data.errorMessage;}
      this.setState({
        bsClass: 'modal-header modal-header-danger',
        modalTitle: 'Error',
        modalMessage: errorMessage,
        LoadingGiftButton: false
      });
    }
  };
  modalClose = () => {this.setState({showModal: false});};
  render() {
    return (
      <div>
        {this.state.purseObj.purseQty > 0 && this.state.authorized && <div>
          <span className="giveCredits" onClick={this.giftForm}><i className="fa fa-gift fa-fw" aria-hidden="true"/> <i>Give Credits</i></span>
        </div>}
        <Modal show={this.state.showModal} onHide={this.modalClose}>
          <Modal.Header bsClass={this.state.bsClass} closeButton>

            {this.state.modalTitle === 'Give Credits' &&
            this.state.bsClass !== 'modal-header modal-header-danger' &&
            <i className="fa fa-gift fa-fw" aria-hidden="true"/>}

            {this.state.modalTitle === 'Give Credits' &&
            this.state.bsClass === 'modal-header modal-header-danger' &&
            <i className="fa fa-warning fa-fw" aria-hidden="true"/>}

            {this.state.modalTitle === 'Error' && <i className="fa fa-warning fa-fw" aria-hidden="true"/>}
            {this.state.modalTitle === 'Success' && <i className="fa fa-check fa-fw" aria-hidden="true"/>}
            {' '}
            {this.state.modalTitle}

          </Modal.Header>
          <Modal.Body>

            {this.state.modalMessage !== 'GIFT' && this.state.modalMessage}

            {this.state.modalMessage === 'GIFT' && <Row className="show-grid">
              <Col sm={12}>

                {/* Give Credits AND Button */}
                <Col sm={12} xsHidden style={{paddingRight:0, paddingLeft:0}}>
                  <FormGroup bsSize="large" validationState={this.validationState()} style={{marginBottom:0}}>
                    <InputGroup>
                      <InputGroup.Addon><i className="fa fa-money fa-fw" aria-hidden="true"/></InputGroup.Addon>
                      <FormControl
                        type="number"
                        id="creditAmount"
                        placeholder="Credit Amount"
                        value={this.state.creditAmount > 0 ? this.state.creditAmount : ''}
                        onChange={this.handleChange}
                      />
                      <InputGroup.Button bsSize="large">
                        <Button
                          bsStyle={!this.validateForm() ? "default" : "success"}
                          bsSize="large"
                          className="LoaderButton"
                          disabled={!this.validateForm() || this.state.LoadingGiftButton}
                          style={{marginBottom:0}}
                          onClick={this.giveCredits}
                        >{this.state.LoadingGiftButton && <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>}
                          {!this.state.LoadingGiftButton && <i className="fa fa-gift fa-fw" aria-hidden="true"/>}
                          {!this.state.LoadingGiftButton ? "Give Credits" : "Giving Credits…"}
                        </Button>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
                </Col>

                {/* Give Credits */}
                <Col xs={12} smHidden mdHidden lgHidden style={{paddingRight:0, paddingLeft:0}}>
                  <FormGroup bsSize="large" validationState={this.validationState()} style={{marginBottom:10}}>
                    <InputGroup>
                      <InputGroup.Addon><i className="fa fa-money fa-fw" aria-hidden="true"/></InputGroup.Addon>
                      <FormControl
                        type="number"
                        id="creditAmount"
                        placeholder="Credit Amount"
                        value={this.state.creditAmount > 0 ? this.state.creditAmount : ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                {/* Give Credits Button */}
                <Col xs={12} smHidden mdHidden lgHidden style={{paddingRight:0, paddingLeft:0}}>
                  <Button
                    bsStyle={!this.validateForm() ? "default" : "success"}
                    bsSize="large"
                    className="LoaderButton"
                    disabled={!this.validateForm() || this.state.LoadingGiftButton}
                    style={{marginBottom:0}}
                    onClick={this.giveCredits}
                    block
                  >
                    {this.state.LoadingGiftButton && <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>}
                    {!this.state.LoadingGiftButton && <i className="fa fa-gift fa-fw" aria-hidden="true"/>}
                    {!this.state.LoadingGiftButton ? "Give Credits" : "Giving Credits…"}
                  </Button>
                </Col>

                {this.state.creditAmount > 0 && this.state.creditAmount <= this.state.purseObj.purseQty && <div style={{fontSize:10}}>
                  Do you want to give <b>{Number(this.state.creditAmount).toLocaleString('en')}</b> of your credits to <b>{this.props.name}</b>?<br/>
                  You will have <b>{Number(this.state.purseObj.purseQty-this.state.creditAmount).toLocaleString('en')}</b> credits left after you send your gift.
                </div>}

                {this.state.creditAmount > 0 && this.state.creditAmount > this.state.purseObj.purseQty && <div style={{fontSize:10, color:'#c9302c'}}>
                  <i className="fa fa-warning fa-fw" aria-hidden="true"/> You do not have <b>{Number(this.state.creditAmount).toLocaleString('en')}</b> credits to give to <b>{this.props.name}</b>.
                </div>}

              </Col>
            </Row>}

          </Modal.Body>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Profile/GiveCredits.js